import { resolveFilterDate, resolveFilterDateEnd } from 'shared/helpers/parsers/dateFilterParser';

const parsePoolAccountJournalFilters = filters => ({
  ...filters,
  createdAtFrom: resolveFilterDate(filters.createdAtFrom),
  createdAtTo: resolveFilterDateEnd(filters.createdAtTo),
});

export { parsePoolAccountJournalFilters };
